import { MijnRoute } from '../mijn-navigatie.model';

export const AFSPRAKENBEHEER: MijnRoute = {
    path: 'afspraken',
    navigationEvent: 'toAfsprakenbeheer',
    regex: /^\/contact\/afspraken$/,
    webcomponent: 'mijn-klant-afsprakenbeheer-wrapper'
};
